import { useQuery } from '@tanstack/react-query'
import { useEffect, useState } from 'react'
import { getMatchList } from '../../../api/agencyAdmin/match';
import { useDebouncedState, useWindowScroll } from '@mantine/hooks';
import { notifications } from '@mantine/notifications';

function useGetMatch() {

    const [scroll, scrollTo] = useWindowScroll()

    const [totalRows, setTotalRows] = useState(0);
    const [perPage, setPerPage] = useState(10);
    const [search, setSearch] = useDebouncedState('', 500);
    const [page, setPage] = useState(1);
    useEffect(() => {
        scrollTo({ y: 0 })
    }, [page]);
    const MatchQuery = useQuery({
        queryFn: () => getMatchList({
            search,
            page: page,
            per_page: perPage,

        }),
        queryKey: ["match_list", perPage, page, search],

        placeholderData: (previousData,) => previousData, // identity function with the same behaviour as `keepPreviousData`,


    });

    const { isPending, isFetching, data } = MatchQuery

    useEffect(() => {
        if (!isPending && !isFetching) {
            notifications.clean()
        }

        if (data) {
            setTotalRows(data?.meta?.total)
        }

    }, [isPending, isFetching]);




    const handlePageChange = async (newPerPage) => {

        setPage(newPerPage);


    };


    const handleChangePerPage = (perPage, page) => {
        setPerPage(perPage);
        setPage(page)

    }

    return {
        MatchQuery,
        totalRows,
        handlePageChange,
        search,
        setSearch,
        handleChangePerPage
    }
}

export default useGetMatch
